/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class SectionFour extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-5-et section p151-bg --slategrey block-4 z-13">
                    <div className="container relative-text">
                        <div className="row mb0">
                            <div className="col s12 m12 l7 left-align mobile-center">
                                <h1 className="f-100-long white-text text-uppercase left-align m0" >STARTUP DAY <br/></h1>
                                <span  className="f-38 white-text text-uppercase left-align">
                                    AT PILOTO 151 </span>


                                <br className="hide-on-large-only"/>
                                <p className="flow-text white-text">
                                    Join us at the first Co-working space in Puerto Rico where we will discuss the top things you need to focus on as a new entrepreneur and how to scale your business. Experience the energy, ambition & opportunity of <span className="brand-text">Puerto Rico’s </span> rapidly growing startup Ecosystem. </p>


                                <br/>
                                <img src="./static/p151-white.png" alt="p151" />
                                <br/>

                            </div>
                            <div className="col s12 m10 offset-m1 l5 center-align">
                                <br/>
                                <img className="img-neg-m img-sticky img-reverse" src="../static/sofia-stolberg.png" alt="sofia-stolberg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default SectionFour;


// WEBPACK FOOTER //
// ./src/components/section-four.js